import { connect } from "react-redux";
import { Selectors } from "@/store/clientProfile/selectors";
import { Selectors as BasketSelectors } from "@/store/basket/selectors";
import { Actions as ModalActions } from "@/store/modals/slice";
import Aside from "./";

const mSp = (state) => ({
  isOwner: Selectors.isOwner(state),
  masters: Selectors.getMasters(state),
  contacts: Selectors.getContacts(state),
  basket: BasketSelectors.getBasket(state),
  achieves: Selectors.getAchieves(state),
  basketAmount: BasketSelectors.getBasketAmount(state),
  basketMaster: BasketSelectors.getMasterId(state),
});
const mDp = {
  openBookingModal: ModalActions.openBooking,
};

export default connect(mSp, mDp)(Aside);
